import * as User from '../../constants/User/CircleList'
import axios from 'axios'
import * as SG from '../../constants/AppSettings'
import { noticeAdd } from '../App'
import { communityUserDefect } from '../Community'

export function circleLoadStart() {
  return {
    type: User.CIRCLE_LOAD_START
  }
}

export function circleLoadEnd() {
  return {
    type: User.CIRCLE_LOAD_END
  }
}

export function getMyCircle(userId) {
  return dispatch => {
    dispatch(circleLoadStart())

    const requestUrl = SG.USER_COMMUNITIES_LIST_URL.replace(/:id/, userId)

    axios.get(requestUrl, { type: 'own', 'headers': { 'Authorization': localStorage.getItem('token') } }).then((r) => {
      dispatch(circleLoadEnd())
      dispatch(getMyCircleResult(r.data.own))
    }).catch((r) => {
      dispatch(noticeAdd('サークル情報を読み込めませんでした', 'error'))
      dispatch(circleLoadEnd())
      dispatch(getMyCircleResult(''))
    });
    return {
      type: User.GET_MY_CIRCLE_LIST
    }
  }
}

export function getMyCircleResult(list) {
  return {
    type: User.GET_MY_CIRCLE_LIST_RESULT,
    list
  }
}


export function getMyJoinedCircle(userId) {
  return dispatch => {
    dispatch(circleLoadStart())

    const requestUrl = SG.USER_COMMUNITIES_LIST_URL.replace(/:id/, userId)

    axios.get(requestUrl, {
      type: 'belong',
      'headers': {
        'Authorization': localStorage.getItem('token')
      }
    }).then((r) => {
      dispatch(circleLoadEnd())
      dispatch(getMyJoinedCircleResult(r.data.belong))
    }).catch((r) => {
      dispatch(noticeAdd('サークル情報を読み込めませんでした', 'error'))
      dispatch(circleLoadEnd())
      dispatch(getMyJoinedCircleResult(''))
    });
    return {
      type: User.GET_MY_JOINED_CIRCLE_LIST
    }
  }

}

export function getMyJoinedCircleResult(list) {
  return {
    type: User.GET_MY_JOINED_CIRCLE_LIST_RESULT,
    list
  }
}

export function communityUserDefectInList(id, userId) {
  return dispatch => {
    dispatch(communityUserDefect(id, userId))
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/CircleList.js